<template>
  <div class="Comparison">
    <div class="title row-center" style="justify-content: left;">
      <div class="row-center" style="font-weight:bold">
        本期时间：
        <el-date-picker
          :editable="false"
          :picker-options="pickerOptions"
          :clearable="false"
          class="dateSelect"
          v-model="date"
          :format="radio === 'week' ? 'yyyy 第 WW 周' : ''"
          :type="radio === 'day' ? 'date' : radio"
          :placeholder="new Date().toLocaleDateString().replace(/\//g, '-')"
        >
        </el-date-picker>

        <div class="radio">
          <el-radio v-model="radio" label="year">年</el-radio>
          <el-radio v-model="radio" label="month">月</el-radio>
          <el-radio v-model="radio" label="week">周</el-radio>
          <el-radio v-model="radio" label="day">日</el-radio>
        </div>
        <el-button plain class="btn per" @click="perD" v-if="radio === 'day'"
          >上一日</el-button
        >
        <el-button plain class="btn per" @click="perM" v-if="radio === 'month'"
          >上一月</el-button
        >
        <el-button plain class="btn per" @click="perW" v-if="radio === 'week'"
          >上一周</el-button
        >
        <el-button plain class="btn per" @click="perY" v-if="radio === 'year'"
          >上一年</el-button
        >
        <el-button
          class="btn next"
          plain
          @click="nextD"
          v-if="radio === 'day'"
          :disabled="nextDayDisabled"
          >下一日
        </el-button>
        <el-button
          class="btn next"
          plain
          @click="nextM"
          v-if="radio === 'month'"
          :disabled="nextDayDisabled"
        >
          下一月
        </el-button>
        <el-button
          class="btn next"
          plain
          @click="nextW"
          v-if="radio === 'week'"
          :disabled="nextDayDisabled"
        >
          下一周
        </el-button>
        <el-button
          class="btn next"
          plain
          @click="nextY"
          v-if="radio === 'year'"
          :disabled="nextDayDisabled"
          >下一年
        </el-button>
      </div>
    </div>
    <div class="cont">
      <div class="tabs-container">
        <span :class="isActive == '-1' ? 'active' : ''" @click="isActive = '-1'"
          >总</span
        >
        <span :class="isActive == '0' ? 'active' : ''" @click="isActive = '0'"
          >电</span
        >
        <span :class="isActive == '1' ? 'active' : ''" @click="isActive = '1'"
          >水</span
        >
        <span :class="isActive == '2' ? 'active' : ''" @click="isActive = '2'"
          >热</span
        >
        <span :class="isActive == '3' ? 'active' : ''" @click="isActive = '3'"
          >冷</span
        >
      </div>
      <div v-if="!canvasShow" class="canvasShow">
        <img
              class="nodata"
              
              src="../../../assets/img/not_found_data.png"
              alt=""
            />
      </div>
      <div class="box"  v-if="canvasShow">
        <div class="charts" style="height:28vh" v-loading="chainloading" >
          <charts id="Comparison" :option="Comparison1"></charts>
        </div>
        <div class="right" v-if="canvasShow">
          <div class="p">环比增长率</div>
          <div class="pare"  :class="{'red':chainLv>0,'green':chainLv<=0}"  v-if="ratioLv!='NaN'">
            {{chainLv!="NaN"?chainLv:'--'}}%<img src="../../../assets/img/shang.png" v-if="chainLv>0"/><img src="../../../assets/img/xia1.png" v-else/>
          </div>
          <div class="pare " v-else> --%</div>
          <div class="line"></div>
          <div class="num">本期总能耗（折标煤）：{{ChainData[1].toFixed(2)}}tce</div>
          <div class="num">上期总能耗（折标煤）：{{ChainData[0].toFixed(2)}}tce</div>
          <div class="num">增长值：{{(ChainData[1]-ChainData[0]).toFixed(2)}}tce</div>
        </div>
      </div>
      <div class="box" v-if="canvasShow" >
        <div class="charts" style="height:28vh"  v-loading="ratioloading">
          <charts id="Comparison1" :option="Comparison2" ></charts>
            
        </div>
        <div class="right">
          <div class="p">同比增长率</div>
          <div class="pare " :class="{'red':ratioLv>0,'green':ratioLv<=0}" v-if="ratioLv!='NaN'">
            {{ratioLv!="NaN"?ratioLv:"--"}}%<img src="../../../assets/img/shang.png" v-if="ratioLv>0"/><img src="../../../assets/img/xia1.png" v-else/>
          </div>
          <div class="pare " v-else> --% </div>
          <div class="line"></div>
          <div class="num">本期总能耗（折标煤）：{{RatioData[1].toFixed(2)}}tce</div>
          <div class="num">同期总能耗（折标煤）：{{RatioData[0].toFixed(2)}}tce</div>
          <div class="num">增长值：{{(RatioData[1]-RatioData[0]).toFixed(2)}}tce</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import charts from "../../../components/Energy/charts";
import { CompareClassifiedPower } from "../../../api/power";
import {
  perDay,
  perMonth,
  perYear,
  nextDay,
  nextMonth,
  nextYear,
  dateFormat,
  addDay,
  getAppointedDate,
} from "../../../util/DateUtil";
export default {
  components: {
    charts,
  },
  props: {
    currentLoop: Object
  },
  data() {
    return {
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      date: new Date(),
      radio: "day",
      isActive: "-1",
      ChainData:[0,0],
      RatioData:[0,0],
      chainloading:true,
      ratioloading:true,
      canvasShow:true
    };
  },
  computed: {
    ratioLv(){
        if(this.RatioData[0]==0){
          return 100
        }else{
          return ((this.RatioData[1]-this.RatioData[0])/this.RatioData[0]*100).toFixed(2)
        }
      
    },
    chainLv(){
      if(this.ChainData[0]!=0){
        return ((this.ChainData[1]-this.ChainData[0])/this.ChainData[0]*100).toFixed(2)
      }else {
        return 100
      }
    },
    node(){
      switch (this.isActive) {
        case "-1":
          return ""
          break;
        case "0":
          return "ELECTRICITY"
          break;
        case "1":
          return "WATER"
          break;
        case "2":
          return "HEAT"
          break;
        case "3":
          return "COOLING"
          break;
      }
    },
    nextDayDisabled() {
      let timestamp = dateFormat("YY-mm-dd", new Date());
      let endtime = dateFormat("YY-mm-dd", this.date);
      if (this.radio === "year") {
        timestamp = dateFormat("YY", new Date());
        endtime = dateFormat("YY", this.date);
      } else if (this.radio === "month") {
        timestamp = dateFormat("YY-mm", new Date());
        endtime = dateFormat("YY-mm", this.date);
      } else if (this.radio === "week") {
        timestamp = dateFormat("YY-mm-dd", new Date());
        endtime = dateFormat("YY-mm-dd", addDay(this.date, 5));
      }
      if (endtime >= timestamp) {
        return true;
      } else {
        return false;
      }
    },
    propsData(){
      return [
        this.date,
        this.range,
        this.currentLoop,
        this.node
      ]
    },
    Comparison1(){
      return {
        color: ["#0D94FF", "#5AD8A6"],
        tooltip: {
          trigger: "item",
          position: "top",
          formatter: function(obj) {
            return obj.marker + obj.name + ":  " + obj.value;
          },
        },
        grid: {
          left: "7%",
          right: "5%",
          bottom: "1%",
          top: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: ["本期", "上期"],
        },
        yAxis: {
          type: "value",
          name: "tce",
        },
        series: [
          {
            name: "本期",
            type: "bar",
            barWidth: 130,
            data: [Number(this.ChainData[1]).toFixed(2), "-"],
            value: 90,
            stack: "Total",
            itemStyle: {
              color: "#0D94FF",
            },
          },
          {
            name: "上期",
            type: "bar",
            barWidth: 130,
            data: ["-", Number(this.ChainData[0]).toFixed(2)],
            value: 190,
            stack: "Total",
            itemStyle: {
              color: "#5AD8A6",
            },
          },
        ],
      }
    },
    Comparison2(){
      return {
        color: ["#0D94FF", "#5AD8A6"],
        tooltip: {
          trigger: "item",
          position: "top",
          formatter: function(obj) {
            return obj.marker + obj.name + ":  " + obj.value;
          },
        },
        grid: {
          left: "7%",
          right: "5%",
          bottom: "1%",
          top: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: ["本期", "同期"],
        },
        yAxis: {
          type: "value",
          name: "tce",
        },
        series: [
          {
            name: "本期",
            type: "bar",
            barWidth: 130,
            data: [Number(this.RatioData[1]).toFixed(2), "-"],
            value: 90,
            stack: "Total",
            itemStyle: {
              color: "#0D94FF",
            },
          },
          {
            name: "同期",
            type: "bar",
            barWidth: 130,
            data: ["-", Number(this.RatioData[0]).toFixed(2)],
            value: 190,
            stack: "Total",
            itemStyle: {
              color: "#5AD8A6",
            },
          },
        ],
      }
    }
  },
  watch: {
    propsData(){
      this.GetCompareChain();
      this.GetCompareRatio();
    },
    radio(n) {
      this.date = new Date();
    },
  },
  mounted() {
    this.GetCompareChain();
    this.GetCompareRatio();
  },
  methods: {
    //环比
    async GetCompareChain(){
      this.chainloading = true
      let range = this.radio;
      let obj ={
         buildingId:this.currentLoop.id,
         compareType:"ALTERNATE",
         date:dateFormat("YY-mm-dd",this.date)+'T00:00:00Z',
         dateRange:range.toUpperCase(),
         powerType:this.node,
      }
      let response = await CompareClassifiedPower(obj);
      this.ChainData = response.data.data.data[0];
      if(this.ChainData.filter(e=> e!=0).length<=0){
        this.canvasShow = false
      }else{
        this.canvasShow = true
      }
      this.chainloading = false
    },
    //同比
    async GetCompareRatio(){
      this.ratioloading = true
      let range = this.radio;
      let obj ={
         buildingId:this.currentLoop.id,
         compareType:"SEPARATED",
         date:dateFormat("YY-mm-dd",this.date)+'T00:00:00Z',
         dateRange:range.toUpperCase(),
         powerType:this.node,
      }
      let response = await CompareClassifiedPower(obj);
      this.RatioData = response.data.data.data[0];
      this.ratioloading = false
    },
    perW() {
      let week = getAppointedDate(this.date, 1, 1);
      this.date = new Date(week.startDate);
    },
    nextW() {
      let week = getAppointedDate(this.date, 1, -1);
      this.date = new Date(week.startDate);
    },
    perD() {
      this.date = perDay(this.date);
    },
    nextD() {
      this.date = nextDay(this.date);
    },
    perM() {
      this.date = perMonth(this.date);
    },
    nextM() {
      this.date = nextMonth(this.date);
    },
    perY() {
      this.date = perYear(this.date);
    },
    nextY() {
      this.date = nextYear(this.date);
    },
  },
};
</script>

<style scoped lang="less">
.canvasShow{
  text-align: center;
    height: 53vh;
}
.tabs-container {
  display: flex;
  flex-direction: row;
  justify-content: space-left;
  height: 4.5vh;
  span {
    line-height: 60rem;
    border-top: 2px solid #fff;
    font-size: 18rem;
    font-weight: 400;
    margin: 0 10rem;
    cursor: pointer;
    font-weight: bold;
  }
  .active {
    color: #0d94ff;
    border-top: 2px solid #0d94ff;
  }
}
.Comparison {
  height: 100%;
  font-size: 18rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.title {
  background: #ffffff;
  height: 8vh;
  padding-left: 30rem;
  width: 100%;
  .demonstration {
    margin-right: 10rem;
  }
  .block {
    margin-right: 80rem;
  }
  .dateSelect {
    margin-right: 10rem;
  }
  .per {
    margin-left: 10rem;
  }
  .el-radio {
    margin-right: 20rem;
  }
}
.cont {
  height: 80vh;
  width: 100%;
  padding: 0 20rem 20rem 20rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  //   align-items: center;
  .tt {
    font-size: 18rem;
    font-weight: bold;
    height: 8vh;
  }
  .box {
    height: 35vh;
    background: rgba(0, 43, 102, 0.04);
    border-radius: 24rem;
    padding-bottom: 20rem;
    width: 100%;
    padding: 30rem 0 30rem 30rem;

    display: flex;
    .charts {
      width: 55%;
    }
    .right {
      padding-left: 30rem;
      font-weight: bold;
      padding: 2vh 0 0 5vw;
      width: 45%;
      .p {
        font-size: 24rem;
        padding-left: 3vw;
      }
      .pare {
        font-size: 48rem;
        padding-left: 3vw;
        margin-top: 10rem;
        font-family: Source Han Sans CN;
        img {
          height: 30px;
          margin-left: 10rem;
        }
      }
      .red {
        color: #fc2e32;
      }
      .green {
        color: #38ad6c;
      }
      .line {
        border-top: 1px solid rgba(0, 0, 0, 0.15);
        margin-top: 15rem;
        margin-bottom: 25rem;
        &:before {
          content: "";
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: rgba(0, 0, 0, 0.15);
          position: absolute;
          display: inline-block;
          margin-top: -4px;
          margin-left: -7px;
        }
      }
      .num {
        font-size: 18rem;
        line-height: 3.8vh;
        padding-left: 3vw;
      }
    }
  }
}
</style>
